module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4 pv3 ph4 pl-box-shadow"
  }, [_c('div', {
    staticClass: "row col-xs center-xs middle-xs title"
  }, [_c('span', [_vm._v("Verbal RoundTable Engagement")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.liveRoundtableEngagementTooltip),
      expression: "liveRoundtableEngagementTooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "live-roundtable-engagement-data"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7ecd3943!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/analytics/engagementGraphs/liveRoundtableEngagement.vue
// module id = 2166
// module chunks = 61